"use client"
import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import "react";
import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_alert_dialog_c2bcbc55__ from "@radix-ui/react-alert-dialog";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__ from "../lib/utils.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__ from "./button.mjs";
function AlertDialog({ ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_alert_dialog_c2bcbc55__.Root, {
        "data-slot": "alert-dialog",
        ...props
    });
}
function AlertDialogTrigger({ ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_alert_dialog_c2bcbc55__.Trigger, {
        "data-slot": "alert-dialog-trigger",
        ...props
    });
}
function AlertDialogPortal({ ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_alert_dialog_c2bcbc55__.Portal, {
        "data-slot": "alert-dialog-portal",
        ...props
    });
}
function AlertDialogOverlay({ className, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_alert_dialog_c2bcbc55__.Overlay, {
        "data-slot": "alert-dialog-overlay",
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50", className),
        ...props
    });
}
function AlertDialogContent({ className, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(AlertDialogPortal, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(AlertDialogOverlay, {}),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_alert_dialog_c2bcbc55__.Content, {
                "data-slot": "alert-dialog-content",
                className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("bg-grayscale-darker border data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[50%] left-[50%] z-50 grid w-full max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] gap-4 rounded-[16px] p-6 shadow-lg duration-200 sm:max-w-lg", className),
                ...props
            })
        ]
    });
}
function AlertDialogHeader({ className, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        "data-slot": "alert-dialog-header",
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("flex flex-col gap-0.5 text-center sm:text-left", className),
        ...props
    });
}
function AlertDialogFooter({ className, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        "data-slot": "alert-dialog-footer",
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("flex flex-col-reverse gap-2 sm:flex-row sm:justify-end", className),
        ...props
    });
}
function AlertDialogTitle({ className, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_alert_dialog_c2bcbc55__.Title, {
        "data-slot": "alert-dialog-title",
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("text-lg font-semibold", className),
        ...props
    });
}
function AlertDialogDescription({ className, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_alert_dialog_c2bcbc55__.Description, {
        "data-slot": "alert-dialog-description",
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("text-secondary-foreground text-sm", className),
        ...props
    });
}
function AlertDialogAction({ className, variant, size, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_alert_dialog_c2bcbc55__.Action, {
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)((0, __WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.buttonVariants)({
            variant,
            size
        }), className),
        ...props
    });
}
function AlertDialogCancel({ className, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_alert_dialog_c2bcbc55__.Cancel, {
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)((0, __WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.buttonVariants)({
            variant: "tertiary"
        }), className),
        ...props
    });
}
export { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, AlertDialogPortal, AlertDialogTitle, AlertDialogTrigger };
